const state = {
    selectedSites: [],
    reportType: 0,
    // for asset reports
    selectedAssetTypes: [],
    selectedFaultTypes: [],
    selectedFilterOptions: {},
    selectedReportDetails: [],
    selectedMaintenanceAssetType: 'Asset',

    selectedRange: null,
    customRange: {
        value: null,
        interval: 'days'
    },

    selectedMaintenanceScale: null,
    selectedAttendanceScale: null,
    selectedManagmentScale: null,
    selectedActivityScale: null,

    schedulingDetails: {}
};

const getters = {
    getSites: (state) => state.selectedSites,
    getAssetTypes: (state) => state.selectedAssetTypes,
    getFaultTypes: (state) => state.selectedFaultTypes,
    getReportType: (state) => state.reportType,
    getSelectedFilterOptions: (state) => state.selectedFilterOptions,
    getSelectedReportDetails: (state) => state.selectedReportDetails,
    getSelectedRange: (state) => state.selectedRange,
    getMaintenanceSelectedAssetType: (state) => state.selectedMaintenanceAssetType,
    getCustomRange: (state) => state.customRange,
    getSchedulingDetails: (state) => state.schedulingDetails
};

const mutations = {
    ADD_SITE(state, site) {
        if (!state.selectedSites.find(s => s.site_id === site.site_id)) {
            state.selectedSites.push(site);
        }
    },
    REMOVE_SITE(state, site) {
        state.selectedSites = state.selectedSites.filter(s => s.site_id !== site.site_id);
    },
    SET_SITES(state, sites) {
        state.selectedSites = sites;
    },
    CLEAR_SITES(state) {
        state.selectedSites = [];
    },

    ADD_ASSET_TYPE(state, type) {
        if (!state.selectedAssetTypes.find(s => s.asset_type === type.asset_type)) {
            state.selectedAssetTypes.push(type);
        }
    },
    REMOVE_ASSET_TYPE(state, type) {
        state.selectedAssetTypes = state.selectedAssetTypes.filter(s => s.asset_type !== type.asset_type);
    },
    SET_ASSET_TYPES(state, types) {
        state.selectedAssetTypes = types;
    },
    CLEAR_ASSET_TYPES(state) {
        state.selectedAssetTypes = [];
    },

    ADD_FAULT_TYPE(state, type) {
        if (!state.selectedFaultTypes.find(s => s.fault_type === type.fault_type)) {
            state.selectedFaultTypes.push(type);
        }
    },
    REMOVE_FAULT_TYPE(state, type) {
        state.selectedFaultTypes = state.selectedFaultTypes.filter(s => s.fault_type !== type.fault_type);
    },
    SET_FAULT_TYPES(state, types) {
        state.selectedFaultTypes = types;
    },
    CLEAR_FAULT_TYPES(state) {
        state.selectedFaultTypes = [];
    },

    SELECT_REPORT_TYPE(state, reportType) {
        state.reportType = reportType
    },

    SELECT_FILTERS(state, filters) {
        console.log('SELECT_FILTERS', filters)
        // Filter out empty arrays before storing
        const filteredFilters = {}
        Object.keys(filters).forEach(key => {
            if (filters[key] && filters[key].length > 0) {
                filteredFilters[key] = filters[key]
            }
        })
        state.selectedFilterOptions = { ...filteredFilters }
        console.log('state.selectedFilterOptions', state.selectedFilterOptions)
    },

    SELECT_REPORT_DETAILS(state, details) {
        state.selectedReportDetails = details
    },

    SET_SCHEDULING_DETAILS(state, schedulingDetails) {
        state.schedulingDetails = schedulingDetails
    },

    SELECT_RANGE(state, range) {
        state.selectedRange = range
    },

    REMOVE_RANGE(state) {
        state.selectedRange = null
    },

    SET_CUSTOM_RANGE_VALUE(state, value) {
        state.customRange.value = value
    },

    SET_CUSTOM_RANGE_INTERVAL(state, interval) {
        state.customRange.interval = interval
    },

    SELECT_MAINTENANCE_ASSET_TYPE(state, assetType) {
        state.selectedMaintenanceAssetType = assetType
    },

    CLEAR_CUSTOM_RANGE(state) {
        state.customRange = {
            value: null,
            interval: 'days'
        }
    }
};

const actions = {
    addSite({ commit }, site) {
        commit('ADD_SITE', site);
    },
    removeSite({ commit }, site) {
        commit('REMOVE_SITE', site);
    },
    setSites({ commit }, sites) {
        commit('SET_SITES', sites);
    },
    clearSites({ commit }) {
        commit('CLEAR_SITES');
    },

    addAssetType({ commit }, type) {
        commit('ADD_ASSET_TYPE', type);
    },
    removeAssetType({ commit }, type) {
        commit('REMOVE_ASSET_TYPE', type);
    },
    setAssetTypes({ commit }, types) {
        commit('SET_ASSET_TYPES', types);
    },
    clearAssetTypes({ commit }) {
        commit('CLEAR_ASSET_TYPES');
    },

    addFaultType({ commit }, type) {
        commit('ADD_FAULT_TYPE', type);
    },
    removeFaultType({ commit }, type) {
        commit('REMOVE_FAULT_TYPE', type);
    },
    setFaultTypes({ commit }, types) {
        commit('SET_FAULT_TYPES', types);
    },
    clearFaultTypes({ commit }) {
        commit('CLEAR_FAULT_TYPES');
    },

    selectReportType({commit}, reportType) {
        commit('SELECT_REPORT_TYPE', reportType)
    },

    selectFilterOptions({commit}, filters) {
        commit('SELECT_FILTERS', filters)
    },

    selectReportDetails({commit}, details) {
        commit('SELECT_REPORT_DETAILS', details)
    },

    setSchedulingDetails({commit}, schedulingDetails) {
        commit('SET_SCHEDULING_DETAILS', schedulingDetails)
    },

    selectRange({commit}, range) {
        commit('SELECT_RANGE', range)
    },

    removeRange({commit}) {
        commit('REMOVE_RANGE')
    },

    setCustomRangeValue({commit}, value) {
        commit('SET_CUSTOM_RANGE_VALUE', value)
    },

    setCustomRangeInterval({commit}, interval) {
        commit('SET_CUSTOM_RANGE_INTERVAL', interval)
    },

    clearCustomRange({commit}) {
        commit('CLEAR_CUSTOM_RANGE')
    },

    selectMaintenanceAssetType({commit}, assetType) {
        commit('SELECT_MAINTENANCE_ASSET_TYPE', assetType)
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};